<template lang="pug">
.send-message-group-family-detail-modal
  b-modal(ref="modal" size="xl" no-close-on-backdrop no-close-on-esc hide-footer)
    template(#modal-header="{ cancel }")
      .send-message-group-family-detail-modal-header
        span {{ groupName }}
      button.close(type="button" @click="cancel") ×

    .send-message-group-family-detail-modal-table
      .thead
        .header-line
          .th.send-type 送信手段
          .th.family-name 家族ユーザー名
          .th.relation 続柄
          .th.position 役割
          .th.room 部屋名
          .th.resident-name 利用者名
      .tbody
        .body-line(v-for="groupMember in _value")
          .td.send-type.center {{ getSenderType(groupMember.senderType) }}
          .td.family-name {{ groupMember.familyName }}
          .td.relation {{ groupMember.familyRelation }}
          .td.position(v-if="groupMember.familyPosition") {{ groupMember.familyPosition }}
          .td.position(v-else) 未設定
          .td.room {{ groupMember.room }}
          .td.resident-name {{ groupMember.name}}
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { SenderType } from "@/commons/models/Resident";
import { SendMessageGroupMembersFamilyGetModel } from "@/commons/services/SendMessageGroupMembers";

/**
 * 宛先グループメンバーリストモーダル
 */
@Component
export default class SendMessageGroupFamilyDetailModal extends Vue {
  /**
   * 宛先グループメンバー
   */
  @Prop({
    default: () => {
      return [];
    }
  })
  value!: Array<SendMessageGroupMembersFamilyGetModel>;
  /**
   * 宛先グループ名
   */
  @Prop({
    default: () => {
      return "";
    }
  })
  groupName!: string;

  /**
   * モーダル表示
   */
  public show(): void {
    const modal: any = this.$refs.modal;
    if (modal) {
      modal.show();
    }

    return;
  }

  get _value(): Array<SendMessageGroupMembersFamilyGetModel> {
    return this.value;
  }

  public getSenderType(senderType: SenderType): string {
    if (senderType == SenderType.LINE) {
      return "LINE";
    } else if (senderType == SenderType.MAIL) {
      return "メール";
    } else {
      return "";
    }
  }
}
</script>
